import USER_ROLES from '../../constants/user-roles'
import { get } from 'lodash'

const isStudent = (user) => (get(user, 'rolesCode', '') || '').includes(USER_ROLES.STUDENT)

export default isStudent